import { createSlice } from "@reduxjs/toolkit";
import { initialTozyState } from "./tozy.state";
import { getAiControl, sendMessage, getMessages } from "./tozy.thunk";
import { TozyMessage } from "./tozy.types";

function normalizeMessage(msg: TozyMessage): TozyMessage {
  return {
    ...msg,
    products: msg.products?.map((p) => ({
      ...p,
      price: String(p.price),
      list_price: String(p.list_price),
    })),
  };
}

export const tozySlice = createSlice({
  name: "tozy",
  initialState: initialTozyState,
  reducers: {
    resetTozy: () => initialTozyState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAiControl.pending, (state) => {
        state.controlStatus = "loading";
        state.error = null;
      })
      .addCase(getAiControl.fulfilled, (state, action) => {
        state.controlStatus = "success";
        state.control = action.payload.data;
      })
      .addCase(getAiControl.rejected, (state, action) => {
        state.controlStatus = "error";
        state.error = action.payload ?? "Hata oluştu";
      })

      .addCase(getMessages.pending, (state) => {
        state.messagesStatus = "loading";
      })
      .addCase(getMessages.fulfilled, (state, action) => {
        state.messagesStatus = "success";
        const { items, pagination } = action.payload.data;
        // Reverse to get chronological order, then prepend (older msgs go above)
        const normalized = [...items].reverse().map(normalizeMessage);
        state.messages = [...normalized, ...state.messages];
        state.pagination = pagination;
      })
      .addCase(getMessages.rejected, (state, action) => {
        state.messagesStatus = "error";
        state.error = action.payload ?? "Hata oluştu";
      })

      .addCase(sendMessage.pending, (state) => {
        state.sendStatus = "loading";
      })
      .addCase(sendMessage.fulfilled, (state, action) => {
        state.sendStatus = "idle";
        state.messages.push(normalizeMessage(action.payload.data));
      })
      .addCase(sendMessage.rejected, (state, action) => {
        state.sendStatus = "error";
        state.error = action.payload ?? "Hata oluştu";
      });
  },
});

export const { resetTozy } = tozySlice.actions;
export default tozySlice.reducer;